// eslint-disable-next-line import/prefer-default-export
export const STATUS = Object.freeze({
  SUCCESS: 'success',
  FAILURE: 'failure',
});
